import React from 'react'
import ArrowRightSvg from 'images/modules/Shared/i-arrow-right-customer.svg?raw'

export { default as ArrowRightCustomerUrl } from 'images/modules/Shared/i-arrow-right-customer.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: ArrowRightSvg}} />
)
